export const HASURA_CLAIMS_NAMESPACE = 'https://hasura.io/jwt/claims';
export const HASURA_ALLOWED_ROLES_KEY = 'x-hasura-allowed-roles';
export const HASURA_ROLE_KEY = 'x-hasura-role';
